module.exports = __webpack_public_path__ + "img/title-1.ed960061.png";